import React, { ChangeEvent, useCallback, useRef, useState } from "react";
import "./FileUploader.css";
import { Button, HStack, IconButton, Text } from "@chakra-ui/react";
import { AttachmentIcon } from "@chakra-ui/icons";

interface FileUploaderProps {
  handleFile: (handleFile: File) => void;
}
export const FileUploader = ({ handleFile }: FileUploaderProps) => {
  const [file, setFile] = useState<File | null>(null);
  const hiddenFileInput = useRef<HTMLInputElement>(null);

  const onClick = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    hiddenFileInput.current?.click();
  }, []);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const fileUploaded = event.target as HTMLInputElement & {
      files: FileList;
    };
    handleFile(fileUploaded.files[0]);
    setFile(fileUploaded.files[0]);
  };

  return (
    <>
      <HStack>
        <IconButton
          variant="solid"
          colorScheme="gray"
          aria-label={"Carica logo"}
          onClick={onClick}
          icon={<AttachmentIcon />}
        />
        {file && <Text>{file.name}</Text>}
        {!file && <Text>Carica un file</Text>}
      </HStack>
      <input
        id={"file"}
        type="file"
        onChange={handleChange}
        accept="image/png, image/jpg, image/jpeg"
        ref={hiddenFileInput}
        style={{ display: "none" }} // Make the file input element invisible
      />
    </>
  );
};
